import { Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import "../../styles/bulletinAdmin/components/bulletinAddSection.scss";

export default function AddSectionCard({ onClick }) {
  return (
    <div className="add-section-wrapper">
      <Card bordered={false} className="add-section-card" onClick={onClick}>
        <div className="card-content">
          <PlusOutlined className="plus-icon" />
          <p>Add a new section</p>
        </div>
      </Card>
    </div>
  );
}
